<template>
  <div>
    <h3 class="mb-3 t-500">
      General information
      <editable v-if="$can.edit(scope, item.rw_access)"
        :isActive="false"
        :text="`Edit`"
        @create="handleEdit()">
      </editable>
    </h3>

    <!-- render contact information -->
    <div class="position-relative">
      <p v-if="item.foundation_year" class="mb-1 block-fa clearfix">
        <i class="fa fa-calendar t-sm t-secondary"></i><span>Foundation date: {{ item.foundation_year }}</span>
      </p>

      <p v-if="item.street || item.city || item.post_code || item.country" class="mb-1 block-fa-span clearfix">
        <i class="fa fa-map-marker text-center t-sm t-secondary"></i>
        <span>
          {{ getFullAddress(item.street, item.city, item.post_code, item.country)}}
          <span v-if="item.country" class="position-absolute ml-2 t-sm"><flag :title="renderCountryFlagTooltip(item.country)" :iso="item.country.alpha_2 | lowercase" :squared="false" class="bd-radius" /></span>
        </span>
      </p>

      <p v-if="item.website" class="mb-1 block-fa clearfix">
        <i class="fa fa-link t-xs pr-2 t-secondary"></i>
        <a @click="sendMixPanelEvent(item.website)" :href="item.website | formatWebsite" ref="website" target="_blank" class="t-overflow">Website</a>
      </p>
    </div>
  </div>
</template>

<script>
import Editable from '@/components/shared/Editable'

import MPService from '@/services/mixpanel'

export default {
  name: 'contactInformation',
  components: {
    Editable
  },
  props: {
    scope: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleEdit () {
      this.$events.$emit(`modal:${this.$options.filters.singularize(this.scope)}:open:create`, this.item)
    },
    sendMixPanelEvent (url) {
      let name = this.scope === 'researchers' ? this.getFullName(this.item) : this.item.name
      MPService.websiteClicked(this.$options.filters.singularize(this.scope), this.item.slug, name, url)
    }
  }
}
</script>
